export const MIME_TYPES = {
    image: [
        'image/png',
        'image/jpeg',
        'image/pjpeg',
        'image/tiff',
        'image/x-tiff',
        'image/webp',
        'image/svg+xml',
        'image/x-icon',
        'image/gif',
        'image/jpg',
    ],
    documents: {
        pdf: ['application/pdf'],
        doc: [
            'application/doc',
            'application/ms-doc',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.google-apps.document',
        ],
        excel: [
            'application/excel',
            'application/vnd.ms-excel',
            'application/x-excel',
            'application/x-msexcel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/x-iwork-numbers-sffnumbers',
            'application/vnd.google-apps.spreadsheet',
        ],
        ppt: [
            'application/mspowerpoint',
            'application/powerpoint',
            'application/vnd.ms-powerpoint',
            'application/x-mspowerpoint',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.google-apps.presentation',
        ],
        text: ['application/rtf', 'text/plain'],
        csv: ['text/csv'],
        font: [
            'font/ttf',
            'font/otf',
            'font/woff',
            'font/woff2',
            'application/font-woff',
        ],
    },
    video: [
        'application/x-troff-msvideo',
        'video/avi',
        'video/msvideo',
        'video/x-msvideo',
        'video/quicktime',
        'video/x-quicktime',
        'image/mov',
        'video/avi',
        'video/mp4',
        'application/mp4',
        'video/ogg',
        'video/x-ms-wmv',
        'video/x-ms-asf',
        'video/webm',
    ],
    audio: [
        'audio/aiff',
        'audio/x-midi',
        'audio/x-wav',
        'audio/ogg',
        'audio/webm',
        'audio/mpeg',
        'audio/x-m4a',
    ],
    zip: [
        'application/zip',
        'application/x-zip',
        'application/x-zip-compressed',
        'application/x-compress',
        'application/x-compressed',
        'multipart/x-zip',
    ],
};
export const GOOGLE_DRIVE = 'google_drive';
export const SYSTEM_FOLDER = {
    membership: '[Assets] Memberships',
    contact: '[Assets] Contacts',
    conversations: '[Assets] Conversations',
};
export const CATEGORY_FOLDER = {
    membership: 'memberships',
    contact: 'contactDocuments',
    conversations: 'conversationsAttachment',
    mediaLibrary: 'mediaLibrary',
};
export const PRIVATE_SYSTEM_FOLDER = ['conversations', 'contact_locations'];
export const COLOR_PALETTE = [
    '#155EEF',
    '#FAC515',
    '#EE46BC',
    '#22CCEE',
    '#7A5AF8',
    '#EF6820',
    '#16B364',
];
